import { types } from 'mobx-state-tree';

const StudentLessonTeacher = types.model('StudentLessonTeacher', {
	teacher_first_name: types.optional(types.maybeNull(types.string), ''),
	teacher_id: types.identifierNumber,
	teacher_last_name: types.optional(types.maybeNull(types.string), ''),
	teacher_zoom_access_code: types.maybeNull(types.string),
	teacher_zoom_id: types.maybeNull(types.string),
	teacher_zoom_link: types.maybeNull(types.string),
});

export default StudentLessonTeacher;
